import { useEffect, useState } from "react"
import { URL_BACKEND, URL_RESULTADO_CARRERA } from "../../api/url";
import { Select } from "antd";
import { elToast } from "../../functions/alertas";


const useReporteResultadoExamenCarrera = () => {

    // variables
    const [carreras, setCarreras] = useState([])
    const [loading, setLoading] = useState(true)
    const [datosFechasAplicacion, setDatosFechasAplicacion] = useState([]);
    const [fechaSeleccionada, setFechaSeleccionada] = useState("")

    const { Option } = Select;


    // funciones

    const traerCarreras = () => {

        let body = new FormData();
        body.append( 'funcion', 'traerCarreras' )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( setCarreras )
        .catch( () => alert('Error al recuperar carreras') )
        .finally( () => setLoading( false ) )

    }

    const traerReporte = ( pk_carrera, nom_carrera ) => {

        // validar que haya un filtro por aplicacion
        if (fechaSeleccionada != "") {

            // obtener el número de aplicación de la fecha seleccionada del arreglo "datosFechasAplicacion"
            let datosFechaSeleccionada = datosFechasAplicacion.find( e => {
                if ( e.fecha == fechaSeleccionada ) {
                    return e;
                }
            })

            let numeroAplicacion = datosFechaSeleccionada.aplicacion;

            elToast("Generando reporte", "info3");

            let body = new FormData();
            body.append("pk_carrera", pk_carrera);
            body.append("filtroFechaAplicacion", fechaSeleccionada);
            body.append("numeroAplicacion", numeroAplicacion);

            fetch(URL_RESULTADO_CARRERA, {
                method: 'post',
                body
            })
            .then(r => r.blob())
            .then(d => {

                let nombreCarrera = nom_carrera.toUpperCase();

                let nombrePDF = "RESULTADOS - " + nombreCarrera + " (APLICACIÓN " + numeroAplicacion + ")";

                let pdf = URL.createObjectURL(d);
                // window.open(pdf, "_blank");
                var anchor = document.createElement("a");
                anchor.download = nombrePDF;
                anchor.href = pdf;
                anchor.click();
            })
            .catch(() => alert("Error al generar reporte"))

        }else{

            elToast("Debe haber un filtro por fecha de aplicación para generar el reporte.", "info3");

        }

    }

    const traerDatosFechasAplicacionExamen = () => {

        let body = new FormData();
        body.append("funcion", "traerDatosFechasAplicacionExamen");

        fetch(URL_BACKEND, {
            method: 'post',
            body
        })
        .then(r => r.json())
        .then(d => {
            setDatosFechasAplicacion(d);
        })
        .catch(() => alert("Error al obtener fechas de aplicación"));

    }

    // useEffect
    useEffect(() => {
        traerCarreras();
        traerDatosFechasAplicacionExamen();
    }, [])

    return {
        carreras,
        loading,
        traerReporte,
        Option,
        datosFechasAplicacion,
        setFechaSeleccionada
    }
}

export default useReporteResultadoExamenCarrera
